import { ChevronRightIcon } from "@heroicons/react/24/outline"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const Breadcrumbs = ({ items = [] }) => {
  const texts = TextBundle({ id: "help-center" })

  if (!items || items.length === 0) return null

  return (
    <nav aria-label={texts?.breadcrumb_aria || "Breadcrumb"}>
      <ol className="flex flex-wrap items-center my-0 gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          // the first is the help center's home: named when the texts have loaded, not when the trail was built
          const label = index === 0 ? texts?.help_center || item.label : item.label
          return (
            <li key={index} className="flex items-center gap-1 my-1 md:my-0">
              {index > 0 && (
                <ChevronRightIcon className="w-3.5 h-3.5 text-text_secondary shrink-0" />
              )}
              {!isLast && item.link ? (
                <a
                  href={item.link}
                  onClick={(e) => { e.preventDefault(); if (item.onClick) item.onClick() }}
                  className="text-sm text-text_secondary hover:text-primary transition-colors cursor-pointer no-underline"
                >
                  {label}
                </a>
              ) : (
                <span className={`text-sm ${isLast ? "text-text font-medium" : "text-text_secondary"}`}>
                  {label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
